<template>
  <div class="request-info-root">
    <div v-if="request.requestCode">
      <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.requestCode }}</span> {{ request.requestCode }}</b>
    </div>
    <div v-if="request.requestDate">
      <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.requestDate }}</span> {{ request.requestDate | hijriDate }}</b>
    </div>
    <div v-if="request.status">
      <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.status }}</span> {{ request.status }}</b>
    </div>
    <div v-if="request.caseCode">
      <b><span class="label-highlighted">{{ local.lawsuitRequest.requestInfo.caseCode }}</span>{{ request.caseCode }}</b>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('LawsuitModule');

export default {
  props: {
    requiresVerification: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      request: state => state.submittedRequestInfo,
      auditFields: state => state.lawsuitRequest.auditFields,
    }),
    ...mapGetters(['isEditMode', 'isInternalLawsuit', 'isAuditFieldsDisabled']),
  },
  methods: { ...mapActions(['updateAuditFields']) },
};
</script>

<style lang="scss">
.request-info-root {
  font-size: 13px;

  span {
    margin-right: 5px;
  }
}

    .label-highlighted {
        color: var(--app-primary-color);
    }
</style>
